import axios from 'common/utils/axios';

const activitiesApi = axios('activities');

export const useActivitiesContributors = (params: any) => {
  return activitiesApi.get('contributors', { params });
};
